import { DpdProductVariantExtension } from "./dpd-product-variant-extension"
import { Exclude, Expose, Type, Transform, plainToClass } from "class-transformer"
import { DpdProductVariantOption } from "./dpd-product-variant-option"
import * as _ from "lodash"
import { Product } from "./product"

enum ResolvedBooleanEnum {
  MANDATORY,
  DISABLED,
  OPTIONAL
}

@Exclude()
export class DpdProductVariant {
  @Expose()
  readonly serviceCode!: number

  @Expose()
  readonly serviceBackCode!: number

  @Expose()
  readonly serviceTextCode!: string

  @Expose()
  readonly asCode!: string

  @Expose()
  readonly csvTextCode!: string

  @Expose()
  readonly wsTextCode!: string

  @Expose()
  readonly description!: string

  @Expose()
  readonly productType!: string

  @Expose()
  @Transform(value => {
    return !_.isNil(value) ? value : true
  })
  readonly enabled!: boolean

  [index: string]: any

  @Expose()
  readonly saturdayDelivery!: boolean

  @Expose()
  readonly shipFromShop!: boolean

  @Expose()
  readonly returnParcel!: boolean

  @Expose()
  readonly cashOnDelivery!: boolean

  @Expose()
  readonly exchange!: boolean

  @Expose()
  readonly parcelShop!: boolean

  @Expose()
  readonly sameDay!: boolean

  @Expose()
  readonly document!: boolean

  @Expose()
  readonly b2c!: boolean

  @Expose()
  readonly dimension!: boolean

  @Expose()
  readonly food!: boolean

  @Expose()
  readonly parcelWeight!: string


  //#endregion

  //#region VariantOption
  @Expose()
  @Transform(value => {
    return !_.isNil(value) ? plainToClass(DpdProductVariantOption, value) : new DpdProductVariantOption()
  })
  readonly returnOfDocument!: DpdProductVariantOption

  @Expose()
  @Transform(value => {
    return !_.isNil(value) ? plainToClass(DpdProductVariantOption, value) : new DpdProductVariantOption()
  })
  readonly deskDelivery!: DpdProductVariantOption

  @Expose()
  @Transform(value => {
    return !_.isNil(value) ? plainToClass(DpdProductVariantOption, value) : new DpdProductVariantOption()
  })
  readonly idCheck!: DpdProductVariantOption

  @Expose()
  @Transform(value => {
    return !_.isNil(value) ? plainToClass(DpdProductVariantOption, value) : new DpdProductVariantOption()
  })
  readonly predict!: DpdProductVariantOption


  //#endregion

  @Expose({ name: "filter" })
  filter?: string

  get binary(): number {
    return _.reduce(
      ["saturdayDelivery",
       "returnParcel",
       "cashOnDelivery",
       "exchange",
       "parcelShop",
       "sameDay",
       "document",
       "b2c",
       "food",
      "shipFromShop"],
      (accumulator, dpdProductVariantExtensionName: string) => {
        let result = accumulator.result
        result <<= 1

        const dpdProductVariantExtension: DpdProductVariantExtension = (this as any)[dpdProductVariantExtensionName]

        if (dpdProductVariantExtension) {
          result |= 1
        }

        return { result }
      },
      { result: 0 }
    ).result
  }

  isStrictSubset(dpdProductVariant: DpdProductVariant): boolean {
    const thisBinary = this.binary
    const otherBinary = dpdProductVariant.binary
    return thisBinary !== otherBinary && (thisBinary & otherBinary) === otherBinary
  }
}
